import { Component, OnInit, Output, Input, EventEmitter, ChangeDetectionStrategy } from '@angular/core';
import { ProjetcsService} from '../../projetcs.service';
import { GlobalService} from '../../../shared/services/global.service';
import { FilterService} from '../../../shared/services/filter.service';

@Component({
    selector: 'app-add-unit',
    templateUrl: './add-unit.component.html',
    styleUrls: ['./add-unit.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class AddUnitComponent implements OnInit {
	@Input() projectId:string;
	@Input() unit:any;
	@Input() productionCenters:any;
	
	@Output() closeView  = new EventEmitter<string>();
	@Output() notify  = new EventEmitter<string>();

	units:any = [];
	loading:boolean = false;

	addUnit(){
		var a = {
			'id':null,
			'unit_name':'',
			'unit_number':'',
			'start_date':'',
			'end_date':'',
			'production_center_id':'',
			'cameras':[],
			'live_view': '',
			'chat_view': ''
		}
		this.units.push(a)
	}

	validateCameras(){
		var invalid = false;
		this.units.forEach((unit, i) => {
			var cameraNames = []
			unit.cameras.forEach((camera, ci) => {
				if (camera.camera_name_eng == '') {
					invalid = true;
				} else {
					if (cameraNames.indexOf(camera.camera_name_eng.toUpperCase()) != -1) {
						invalid = true;
					} else {
						cameraNames.push(camera.camera_name_eng.toUpperCase())
					}
				}
			})
		})
		return invalid
	}

	submitForm(){
		this.loading = true;
		this._pS.addUnit(this.projectId, this.units)
	  		.subscribe(
				data => {
				    var rdata:any = data;
				    this.notify.emit();
				    this.loading = false;
				}
			)
	}
	close(){
		this.closeView.emit()
	}
	deleteCamera(ui, i){
		this.units[i].cameras.splice(ui, 1);
	}
	addCamera(i){
		var a = {
			'id':null,
			'camera_name_eng':'',
			'clips':0
		}
		this.units[i].cameras.push(a)
	}

  	constructor(private _pS:ProjetcsService, public _gS:GlobalService, private _fS:FilterService) { }

  	ngOnInit() {
		if (this.unit) {
			var a = {
				'id':this.unit.id,
				'unit_name':this.unit.unit_name,
				'unit_number':this.unit.unit_number,
				'start_date':this.unit.start_date,
				'end_date':this.unit.end_date,
				'production_center_id':this.unit.production_center_id,
				'cameras':this.unit.cameras,
				'live_view': this.unit.live_view,
				'chat_view': this.unit.chat_view
			}
			this.units.push(a)
		} else {
			this.addUnit();
		}
  	}
}
